import { render } from "./ClientVentasPedidoNuevo.vue?vue&type=template&id=60b5b066&scoped=true"
import script from "./ClientVentasPedidoNuevo.vue?vue&type=script&lang=js"
export * from "./ClientVentasPedidoNuevo.vue?vue&type=script&lang=js"

import "./ClientVentasPedidoNuevo.vue?vue&type=style&index=0&id=60b5b066&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b5b066"]])

export default __exports__